import styles from "./CriteriaTag.module.css";
import { Tag } from "antd";
import { criteriaLabelMap } from "../Forms/utils";
import { CriteriaOption } from "../../types/task";

const CriteriaTag = ({
  criteria,
  selected = false,
  onClick,
}: {
  criteria: CriteriaOption;
  selected?: boolean;
  onClick?: () => void;
}) => {
  const className = [
    styles.criteriaTag,
    selected ? styles.selected : "",
    onClick ? styles.clickable : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag key={criteria} className={className} onClick={onClick}>
      {criteriaLabelMap[criteria] || criteria}
    </Tag>
  );
};

export default CriteriaTag;
